import React from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage, getLanguage } from './index';

function Flag({ language }) {
  return language === 'it' ? <svg viewBox="0 0 30 20" width="24" height="16" aria-hidden="true">
    <path fill="#009246" d="M0 0h10v20H0z"/><path fill="#fff" d="M10 0h10v20H10z"/><path fill="#ce2b37" d="M20 0h10v20H20z"/>
  </svg> : <svg viewBox="0 0 60 40" width="24" height="16" aria-hidden="true">
    <path fill="#012169" d="M0 0h60v40H0z"/>
    <path stroke="#fff" strokeWidth="8" d="m0 0 60 40M0 40 60 0"/>
    <path stroke="#c8102e" strokeWidth="3" d="m0 0 60 40M0 40 60 0"/>
    <path stroke="#fff" strokeWidth="13" d="M30 0v40M0 20h60"/>
    <path stroke="#c8102e" strokeWidth="8" d="M30 0v40M0 20h60"/>
  </svg>;
}
export default function LanguageSelector() {
  useTranslation();
  const language = getLanguage();
  return <div role="group" aria-label={language === 'it' ? 'Lingua dell’applicazione' : 'Application language'} className="flex items-center gap-1" data-testid="language-selector">
    {['it', 'en'].map(code => <button key={code} type="button" data-language-control={code}
      onClick={() => changeLanguage(code)} aria-label={code === 'it' ? 'Italiano' : 'English'}
      aria-pressed={code === language} title={code === 'it' ? 'Italiano' : 'English'}
      className={`flex h-11 min-w-11 items-center justify-center gap-1 rounded-md border px-1.5 text-xs font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 active:bg-blue-100 ${code === language ? 'border-blue-600 bg-blue-50 text-blue-700' : 'border-border bg-background text-muted-foreground hover:bg-muted'}`}>
      <Flag language={code}/><span>{code.toUpperCase()}</span>
    </button>)}
  </div>;
}
